
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FlexGrid, FlexItem } from './flexgrid'
import Button from './Button'
import ShowHide from './ShowHide'
import Calendar from './icons/calendar'
import Card from './icons/card'
import Warning from './icons/warning'
import './Banner.css'

const icons = {
  calendar: Calendar,
  card: Card,
  warning: Warning
}

class Banner extends Component {
  render () {
    const { importance, message, icon, cta, onClick, size } = this.props
    const Icon = icons[icon]

    return (
      <div className={`Banner Banner--${importance} Banner--${size}`}>
        <div className='Banner-content'>
          <FlexGrid className='Banner-message' alignItems='center' justifyContent='space-around'>
            <FlexItem>
              <FlexGrid alignItems='center'>
                <FlexItem spaceRight={15}>
                  {Icon && <Icon />}
                </FlexItem>
                <FlexItem>
                  {message}
                </FlexItem>
              </FlexGrid>
            </FlexItem>
          </FlexGrid>
          <div className='Banner-button'>
            <ShowHide show={cta}>
              <Button
                modifier='outlined'
                onClick={onClick}>
                {cta}
              </Button>
            </ShowHide>
          </div>
        </div>
      </div>
    )
  }

  componentDidMount () {
    this.props.onMount(this.props)
  }
}

Banner.defaultProps = {
  onMount: () => {},
  size: 'medium'
}

Banner.propTypes = {
  importance: PropTypes.string,
  message: PropTypes.oneOfType([ PropTypes.object, PropTypes.string ]),
  icon: PropTypes.string,
  cta: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.string.isRequired
}

Banner.displayName = 'Banner'

export default Banner



// WEBPACK FOOTER //
// ./ui/Banner.js